/** Идентификаторы разделов приложения (как в аналитике / API screen-time). */
export const GA_APP_SECTIONS = {
  ORGANIZATIONS: 'organizations',
  EVENTS: 'events',
  ARTICLES: 'articles',
  PAYMENTS: 'payments',
  NOTIFICATIONS: 'notifications',
  OTHER: 'other',
};

/** Человекочитаемые названия для отображения в UI. */
export const GA_APP_SECTION_LABELS = {
  [GA_APP_SECTIONS.ORGANIZATIONS]: 'Организации',
  [GA_APP_SECTIONS.EVENTS]: 'Мероприятия',
  [GA_APP_SECTIONS.ARTICLES]: 'Статьи',
  [GA_APP_SECTIONS.PAYMENTS]: 'Платежи',
  [GA_APP_SECTIONS.NOTIFICATIONS]: 'Уведомления',
  [GA_APP_SECTIONS.OTHER]: 'Другое',
};

/** Рекомендуемый порядок разделов; на графике «по времени» список линий берётся из `section_columns` ответа API. */
export const GA_APP_SECTIONS_CHART_ORDER = [
  GA_APP_SECTIONS.ORGANIZATIONS,
  GA_APP_SECTIONS.EVENTS,
  GA_APP_SECTIONS.ARTICLES,
  GA_APP_SECTIONS.PAYMENTS,
  GA_APP_SECTIONS.NOTIFICATIONS,
  GA_APP_SECTIONS.OTHER,
];

export function getGaAppSectionLabel(sectionId) {
  if (sectionId == null || sectionId === '') return '—';
  return GA_APP_SECTION_LABELS[sectionId] ?? sectionId;
}
